module.exports = __webpack_public_path__ + "static/media/multiclose.cce2a69c.svg";